import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { useTranslation } from "../i18n";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  itemName,
  confirmText,
  cancelText,
  onConfirm,
  isDeleteCard,
  message,
  customContent,
  confirmVariant,
  disabled,
}) {
  const { t } = useTranslation();

  const isDanger =
    confirmVariant === "destructive" || (!confirmVariant && isDeleteCard);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={isDanger ? "border-c-red-500 border-2 max-w-md" : "max-w-md"}
      >
        <DialogHeader>
          <DialogTitle>
            {title ||
              (isDeleteCard
                ? t("confirm.deleteCardTitle")
                : t("confirm.archiveTitle"))}
          </DialogTitle>
        </DialogHeader>
        {customContent ? (
          customContent
        ) : (
          <div className="space-y-3">
            <p className="text-c-gray-300">
              {message ||
                (isDeleteCard
                  ? t("confirm.deleteCardMessage", { item: itemName || "" })
                  : t("confirm.archiveMessage", { item: itemName || "" }))}
            </p>
            {isDanger && (
              <div className="bg-c-red-500/20 border border-c-red-500/30 rounded p-3">
                <p className="text-c-red-400 text-sm">
                  {isDeleteCard
                    ? t("confirm.deleteCardWarning")
                    : t("confirm.archiveWarning")}
                </p>
              </div>
            )}
          </div>
        )}
        <DialogFooter className="flex justify-between sm:justify-between">
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {cancelText || t("common.cancel")}
          </Button>
          <Button
            variant={
              confirmVariant || (isDeleteCard ? "destructive" : "default")
            }
            onClick={onConfirm}
            disabled={disabled}
          >
            {confirmText ||
              (isDeleteCard
                ? t("confirm.deleteCardAction")
                : t("confirm.archiveAction"))}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
